import { motion } from "framer-motion";
import {
  Stethoscope, Building2, Activity, HeartPulse, Microscope, Dumbbell,
  ShieldCheck, PhoneCall, Server, MonitorSmartphone, Wrench,
} from "lucide-react";

export const iconMap = {
  "stethoscope": Stethoscope,
  "building-2": Building2,
  "activity": Activity,
  "heart-pulse": HeartPulse,
  "microscope": Microscope,
  "dumbbell": Dumbbell,
  "shield-check": ShieldCheck,
  "phone-call": PhoneCall,
  "server": Server,
  "monitor-smartphone": MonitorSmartphone,
};

export function Icon({ name, ...props }) {
  const C = iconMap[name] || Wrench;
  return <C {...props} />;
}

const easing = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 24, className = "", as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: easing, delay }}
    >
      {children}
    </M>
  );
}

export function SectionLabel({ children }) {
  return (
    <span className="mf-eyebrow">
      <span className="text-[var(--mf-red)]">{children}</span>
    </span>
  );
}
